

class commonRecharge {
    header() {
        return {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-Shop": window.customerDetails.url,
            "X-Recharge-Version": "2021-11"
        };
    }
    
    rechargeCommonApi(){
        return window.customerDetails.rechargeCommonApi
    }

    shopifyCommonApi(){
        return window.customerDetails.shopifyCommonApi
    }

    rechargeCommonBody(config){
        return {
            method: 'POST',
            headers: this.header(),
            body: JSON.stringify(config)
        }
    }

    async _createSubscriptionProduct(subsDataObj){
        var config = {
            url: `/subscriptions`,
            method: 'POST',
            data: subsDataObj,
            headers: this.header()
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        // Added onetime addon
        if (response.ok) {
            console.log('Subscription created Successfully: ',data)
            return await true;
        }else{
            console.error('error in adding onetime Addon: ',data)
        }
    }
    

    async _updateSubscription(subscription_id,updateSubscriptionObj){
        var config = {
            url: `/subscriptions/${subscription_id}?commit=true`,
            method: 'PUT',
            data: updateSubscriptionObj,
            headers: {
                "Accept": "application/json",
                "X-Recharge-Version": "2021-11"
            }
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        // Updated subscription
        if (response.ok) {
            console.log('Subscription Updated Successfully: ',data)
            return await true;
        }else{
            Utility.notification('Something went wrong','Error in Updating subscription','error')
            console.error('error in updating subscription: ',data)
        }
    }

    async _updatePaymethodMethod(address_id,card_id){
        var config = {
            url: `/customers/${window.customerDetails.rechargeCustomerDetails.id}/notifications`,
            method: 'POST',
            data: {
                'type': 'email',
                'template_vars': {
                    address_id: address_id,
                    payment_method_id: card_id
                },
                'template_type': 'shopify_update_payment_information'
            }
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));

        // Mail Notification
        if (response.ok) {
            console.log('Sent Mail-Notification to the customer: ',response)
            return await true;
        }else{
            Utility.notification('Something went wrong','Error in sending mail notification','error')
            console.warn('There is some error in sending mail notificatio: ',response)
        }
    }

    async _createOnetimeAddon(addonObj){
        var config = {
            url: `/onetimes`,
            method: 'POST',
            data: addonObj,
            headers: {
                "Accept": "application/json",
                "X-Recharge-Version": "2021-11"
            }
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        // Added onetime addon
        if (response.ok) {
            console.log('Addon added Successfully: ',data)
            return await true;
        }else{
            Utility.notification('Payment Error','Please check your account page.' ,'error')
            console.error('error in adding onetime Addon: ',data)
            return await false;
        }
    }
}

var commonAPI = new commonRecharge();
